import { Heading, Typography } from "@sidelinesports/fan-design-system";
import { ListItem } from "../../../components";
import styles from "./NoGamesMessage.module.css";

export const NoGamesMessage = () => (
  <ListItem className={styles["no-games-message"]} textAlign="center">
    <Heading level={4}>No open games</Heading>
    <Typography size="lg" color="muted">
      Come back another time!
    </Typography>
  </ListItem>
);
